
const uniq = require('lodash/uniq')
const isEmpty = require('lodash/isEmpty')
const angular = require('angular')
const serverConfig = require('../../../infrastructure/serverConfig')

module.exports = ['$q', '$scope', '$rootScope', '$translate', 'contactListService', 'contactService', 'contactListMixin', '$stateParams', '$state', '$utils', '$ionicScrollDelegate', '$phoneModal', '$ionicPopup', '$ionicHistory', '$loading', 'LocalStorage',
  function ($q, $scope, $rootScope, $translate, contactListService, contactService, ContactListMixin, $stateParams, $state, $utils, $ionicScrollDelegate, $phoneModal, $ionicPopup, $ionicHistory, $loading, LocalStorage) {
    // 该控制器是联系人新建和编辑，联系组新建和编辑的控制器，因此要根据不同的页面进行初始化操作
    // 这里主要根据URL的不同进行相应页面的初始化

    // 页面类型
    initPageType()
    $scope.memberSelectResult = $translate.instant('ADDRESSBOOK.NO_SELECTED')
    // 新建联系人
    if ($state.current.name === 'frame.createContact' && $stateParams.type === 'create') {
      $scope.contact = {
        groups: []
      }
      initContactCreate()
    }
    // 编辑联系人
    if ($state.current.name === 'frame.createContact' && $stateParams.type === 'edit') {
      $scope.contact = {
        groups: []
      }
      initContactEdit()
    }
    // 新建分组
    if ($state.current.name === 'frame.createGroup' && $stateParams.type === 'create') {
      $scope.newGroup = {
        name: '',
        members: []
      }
      initGroupCreate()
      addSelectStatusListener()
    }
    // 编辑分组
    if ($state.current.name === 'frame.createGroup' && $stateParams.type === 'edit') {
      $scope.newGroup = {
        name: '',
        members: []
      }
      addSelectStatusListener()
      initGroupEdit()
    }
    // 添加到个人通讯录
    if ($state.current.name === 'frame.createContact' && $stateParams.type === 'addToPab') {
      $scope.contact = {
        groups: [],
        'EMAIL;PREF': $stateParams.contactid,
        'FN': $stateParams.name,
      }
      initAddToPab()
    }
    $scope.goBackToEditPage = function () {
      window.history.back()
    }
    $scope.start = 0
    $scope.limit = 20
    $scope.contactsArrUnderGroup = []
    // 根据URL及参数判断页面性质(1.新建 2.编辑)
    function initPageType() {
      if ($stateParams.type === 'create') {
        $scope.pageType = 'create'
      }
      if ($stateParams.type === 'addToPab') {
        $scope.pageType = 'create'
      }
      if ($stateParams.type === 'edit') {
        $scope.pageType = 'edit'
      }
    }
    // 新建联系人初始化
    function initContactCreate() {
      $scope.title = $translate.instant('ADDRESSBOOK.CREATECONTACT.TITLE')
    }
    // 编辑联系人初始化
    function initContactEdit() {
      $scope.contactid = $stateParams.contactid
      $scope.title = $translate.instant('ADDRESSBOOK.EDITCONTACT.TITLE')
      contactService.getContactDetail($scope.contactid).then(function (detail) {
        $scope.contact = {
          ...detail
        }
        const strArr = []
        $scope.contact.groups.forEach(function (item) {
          $rootScope.personalGroupArr.forEach(function (group) {
            if (group.id === item) {
              strArr.push(group.name)
            }
          })
        })
        $scope.groupStr = strArr.join('、')
      }, function (error) {
        console.log(error)
        $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.INIT_FAIL') })
      })
    }
    // 新建分组初始化
    function initGroupCreate() {
      $scope.title = $translate.instant('ADDRESSBOOK.CREATEGROUP.TITLE')
    }
    // 编辑分组初始化
    function initGroupEdit() {
      $scope.groupid = $stateParams.groupid
      $scope.title = $translate.instant('ADDRESSBOOK.EDITGROUP.TITLE')
      isCurrentGroupEmpty($stateParams.groupid)
      isCurrentGroupReserved($stateParams.groupid)
      getEditPageMembers()
    }
    // 添加到个人通讯录的页面初始化
    function initAddToPab() {
      $scope.title = $translate.instant('ADDRESSBOOK.CREATECONTACT.TITLE')
      getOabContact($stateParams.contactid, $stateParams.name)
    }
    // 根据contactid获取对应的组织通讯录的联系人（用于由组织通讯录联系人详情的添加到个人通讯录功能）
    function getOabContact(contactid, name) {
      if ($rootScope.settings.featureControl.addressBook.enableOrganization) {
        contactService.getOabContact(contactid).then(function (data) {
          if (isEmpty(data)) return

          $scope.OabContact = data
          $scope.contact.FN = $scope.OabContact.true_name
          $scope.contact['EMAIL;PREF'] = $scope.OabContact.email
          $scope.contact['TEL;CELL;VOICE'] = $scope.OabContact.mobile_number
          $scope.contact['TEL;WORK;VOICE'] = $scope.OabContact.company_phone
          $scope.contact['TEL;HOME;VOICE'] = $scope.OabContact.home_phone
          $scope.contact['TEL;WORK;FAX'] = $scope.OabContact.fax_number
          contactService.getOabStructureBydn({dn: $scope.OabContact['@ou'], attrIds: 'name'}).then((data) => {
            $scope.contact['ORGNAME'] = data.name + ($scope.OabContact.duty ? ('•' + $scope.OabContact.duty) : '')
          }, () => {})
        }, function () {
        })
      }
    }
    // 打开联系人分组选择模态框
    $scope.openSelectGroupModal = function () {
      $scope.selectGroupModal = $phoneModal.fromTemplate(require('views/addressBook/selectGroupModal.html'), {
        scope: $scope,
        cache: false,
        animation: 'slide-in-up'
      })
      $scope.selectGroupModal.el.style.zIndex = 11
      $utils.$modalFunc.prepareModalBack($scope.selectGroupModal)
      $scope.selectGroupModal.show()
      contactService.getPersonalGroups().then(function (data) {
        $scope.groupsArr = data
        $scope.groupsArr.forEach(function (item) {
          $scope.contact.groups.forEach(function (group) {
            if (item.id === group) {
              item.isChecked = true
            }
          })
        })
      }, function (data) {
        $scope.groupsArr = data
      })
    }
    // 关闭联系人分组选择模态框
    $scope.closeSelectGroupModal = function () {
      window.history.back()
      $scope.selectGroupModal.remove()
    }
    // 打开分组成员选择模态框
    $scope.openSelectGroupMemberModal = function () {
      $scope.selectGroupMemberModal = $phoneModal.fromTemplate(require('views/addressBook/selectGroupMemberModal.html'), {
        scope: $scope,
        cache: false,
        animation: 'slide-in-up'
      })
      $scope.selectGroupMemberModal.el.style.zIndex = 11
      $utils.$modalFunc.prepareModalBack($scope.selectGroupMemberModal)
      $scope.selectGroupMemberModal.show()
      contactService.getPersonalGroups().then(function (data) {
        $scope.groupsArr = data
      }, function (data) {
        $scope.groupsArr = data
      })
    }
    // 关闭分组成员选择模态框
    $scope.closeSelectGroupMemberModal = function () {
      $scope.selectGroupMemberModal.remove()
      $scope.showGroupContacts = null
    }
    // 打开分组成员选择结果模态框
    $scope.openSelectGroupMemberResultModal = function () {
      $scope.selectGroupMemberResultModal = $phoneModal.fromTemplate(require('views/addressBook/selectGroupMemberResultModal.html'), {
        scope: $scope,
        cache: false,
        animation: 'slide-in-right'
      })
      $scope.selectGroupMemberResultModal.el.style.zIndex = 10
      $scope.selectGroupMemberResultModal.show()
    }
    // 隐藏分组成员选择结果模态框
    $scope.hideResultModal = function () {
      $scope.selectGroupMemberResultModal.hide()
    }
    // 返回新建联系人或新建联系组页面
    $scope.goBack = function () {
      $scope.selectGroupModal && $scope.selectGroupModal.remove()
      $scope.selectGroupMemberModal && $scope.selectGroupMemberModal.remove()
      $utils.$modalFunc.endModalBack()
    }
    // 新建联系人页面的返回操作
    $scope.createContactGoBack = function() {
      window.history.go(-1)
    }
    // 保存新建联系人分组选择结果
    $scope.confirm = function () {
      const strArr = []
      $scope.contact.groups = []
      $scope.groupsArr.forEach(function (item) {
        if (item.isChecked) {
          strArr.push(item.name)
          $scope.contact.groups.push(item.id)
        }
      })
      $scope.groupStr = strArr.join('、')

      $scope.selectGroupModal.hide()
    }
    // 保存新建分组成员选择结果
    $scope.saveSelectedGroupContacts = function () {
      const temp = []
      $scope.contactsArrUnderGroup.forEach(function (item) {
        if (item.isChecked && !isAlreadySelected(item)) {
          temp.push(item)
        }
      })
      $scope.newGroup.members = $scope.newGroup.members.concat(temp)
      $rootScope.selectMemberResult = $scope.newGroup.members
      if ($scope.newGroup.members.length !== 0) {
        $scope.memberSelectResult = $translate.instant('ADDRESSBOOK.SELECTED') + '(' + $scope.newGroup.members.length + ')'
      } else {
        $scope.memberSelectResult = $translate.instant('ADDRESSBOOK.NOSELECTED')
      }
      $scope.selectGroupMemberModal.remove()
      $scope.showGroupContacts = null
      resetStatus()
    }
    // 判断添加的新成员是否与已选中的重复
    function isAlreadySelected(contact) {
      let selected
      $scope.newGroup.members.forEach(function (item) {
        if (item.id === contact.id) {
          selected = true
        }
      })
      if (selected) {
        return true
      } else {
        return false
      }
    }
    // 添加已选择成员统计的更新的监听器，用于添加的成员发生变化的话文字说明的刷新
    function addSelectStatusListener() {
      $rootScope.$on('addressbook.selectStatusRefresh', function () {
        if ($scope.newGroup.members.length !== 0) {
          $scope.memberSelectResult = $translate.instant('ADDRESSBOOK.SELECTED') + '(' + $scope.newGroup.members.length + ')'
        } else {
          $scope.memberSelectResult = $translate.instant('ADDRESSBOOK.NO_SELECTED')
        }
      })
    }
    // 移除已选择的分组成员
    $scope.moveOut = function (contactid) {
      let moveOutIndex
      $scope.newGroup.members.forEach(function (contact, index) {
        if (contactid === contact.id) {
          moveOutIndex = index
        }
      })
      $scope.newGroup.members.splice(moveOutIndex, 1)
      $scope.$emit('addressbook.selectStatusRefresh')
    }
    // 创建新联系人保存
    $scope.createContactSave = function () {
      if (!$scope.contact['FN']) {
        $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.CREATECONTACT.EMPTY_NAME') })
        return
      }
      if (!$scope.contact['EMAIL;PREF']) {
        $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.CREATECONTACT.EMPTY_EMAIL') })
        return
      }
      if (!$utils.$email.test($scope.contact['EMAIL;PREF'])) {
        $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.CREATECONTACT.INVALID_EMAIL') })
        return
      }
      contactService.createPabContact($scope.contact).then(function (data) {
        if (data && data.code === 'S_OK') {
          $scope.$emit('showToast', { message: $translate.instant('ADDRESSBOOK.CREATECONTACT.SAVE_SUCCESS') })
          $state.go('frame.personalContactDetail', {contactid: data.var[0]})
        }
      }, function (errorCode) {
        if (errorCode === 'FA_FORBIDDEN') {
          $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.CREATECONTACT.FA_FORBIDDEN') })
        } else if (errorCode === 'FA_OVERFLOW') {
          $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.CREATECONTACT.FA_OVERFLOW') })
        } else if (errorCode === 'FA_EMAIL_EXISTS') {
          $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.CREATECONTACT.FA_EMAIL_EXISTS') })
        } else if (errorCode === 'FA_GROUP_NOT_FOUND') {
          $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.CREATECONTACT.FA_GROUP_NOT_FOUND') })
        } else {
          $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.CREATECONTACT.CREATE_FAIL') })
        }
      })
    }
    // 编辑联系人保存
    $scope.editContactSave = function () {
      if (!$scope.contact['FN']) {
        $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.EDITCONTACT.EMPTY_NAME') })
        return
      }
      if (!$scope.contact['EMAIL;PREF']) {
        $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.EDITCONTACT.EMPTY_EMAIL') })
        return
      }
      if (!$utils.$email.test($scope.contact['EMAIL;PREF'])) {
        $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.EDITCONTACT.INVALID_EMAIL') })
      }
      contactService.updatePabContactDetail($scope.contact).then(function (data) {
        if (data && data.code === 'S_OK') {
          $scope.$emit('showToast', { message: $translate.instant('ADDRESSBOOK.EDITCONTACT.SAVE_SUCCESS') })
          window.history.back()
        }
      }, function (error) {
        if (error.code === 'FA_FORBIDDEN') {
          $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.EDITCONTACT.FA_FORBIDDEN') })
        } else if (error.code === 'FA_ID_NOT_FOUND') {
          $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.EDITCONTACT.FA_ID_NOT_FOUND') })
        } else if (error.code === 'FA_EMAIL_EXISTS') {
          $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.EDITCONTACT.FA_EMAIL_EXISTS') })
        } else {
          $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.EDITCONTACT.EDIT_FAIL') })
        }
      })
    }
    // 创建新分组保存（创建分组分两个步骤：1、更新分组 2、更新新分组选择的成员的groups状态，对应updateAllGroups和updateContacts接口）
    // 新建时无需带上分组id
    $scope.createGroupSave = function () {
      if (!$scope.newGroup.name) {
        $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.CREATEGROUP.EMPTY_GROUPNAME') })
        return
      }
      hasSameNameGroup($scope.newGroup.name).then(function (data) {
        if (data === 'true') {
          $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.CREATEGROUP.SAME_NAME_GROUP') })
        }
      }, function (data) {
        if (data === 'false') {
          createGroupProcess()
        }
      })
    }
    // 创建分组详细过程
    function createGroupProcess() {
      $loading.show($translate.instant('ADDRESSBOOK.CREATEGROUP.GROUP_CREATING'))
      let params = {}
      params = {
        groups: [{ name: $scope.newGroup.name, reserved: false }]
      }
      contactListService.getAllGroups().then(function(data) {
        if (data && data.code === 'S_OK') {
          params.groups = params.groups.concat(data.var)
          contactListService.updateAllGroups(params).then(function (data) {
            if (data.code === 'S_OK') {
              data.var.forEach(function (item) {
                if (item.name === $scope.newGroup.name) {
                  $scope.groupid = item.id
                }
              })
              addGroupMember().then(function (result) {
                if (result === 'success') {
                  $loading.hide()
                  $scope.$emit('showToast', { message: $translate.instant('ADDRESSBOOK.EDITGROUP.SAVE_SUCCESS') })
                  $state.go('frame.personalContact')
                }
              }, function (result) {
                if (result === 'fail') {
                  $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.CREATEGROUP.FAIL_TO_ADDMEMBER') })
                  $state.go('frame.personalContact')
                }
              })
            }
          }, function (error) {
            console.log(error)
            $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.CREATEGROUP.CREATE_FAIL') })
          }).finally(function () {
          })
        }
      }, function(error) {
        console.log(error)
      })
    }
    // 校验是否有同名的联系组
    function hasSameNameGroup(name) {
      const deferred = $q.defer()
      contactListService.getAllGroups().then(function (data) {
        if (data.code === 'S_OK') {
          let flag = false
          data.var.forEach(function (item) {
            if (item.name === name) {
              flag = true
              deferred.resolve('true')
            }
          })
          !flag && deferred.reject('false')
        }
      })
      return deferred.promise
    }
    // 编辑分组保存,系统保留分组无法重命名
    $scope.editGroupSave = function () {
      // 系统分组保存操作只做成员更新
      if ($scope.isCurrentGroupReserved) {
        $loading.show($translate.instant('ADDRESSBOOK.EDITGROUP.SAVING'))
        addGroupMember($scope.groupid).then(function (result) {
          if (result === 'success') {
            $loading.hide()
            $scope.$emit('showToast', { message: $translate.instant('ADDRESSBOOK.EDITGROUP.SAVE_SUCCESS') })
            $state.go('frame.personalContactList', { groupid: $scope.groupid })
          }
        }, function (result) {
          if (result === 'fail') {
            $loading.hide()
            $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.EDITGROUP.MEMBER_UPDATE_FAIL') })
            $state.go('frame.personalContact')
          }
        })
      } else {
        $loading.show($translate.instant('ADDRESSBOOK.EDITGROUP.SAVING'))
        let params = {}
        params = {
          groups: [{ name: $scope.newGroup.name, reserved: false, id: $scope.groupid }]
        }
        contactListService.getAllGroups().then(function(data) {
          if (data && data.code === 'S_OK') {
            data.var.forEach(function(item) {
              if (item.id !== $scope.groupid) {
                params.groups.push(item)
              }
            })
            contactListService.updateAllGroups(params).then(function (data) {
              if (data.code === 'S_OK') {
                addGroupMember($scope.groupid).then(function (result) {
                  if (result === 'success') {
                    $loading.hide()
                    $scope.$emit('showToast', { message: $translate.instant('ADDRESSBOOK.EDITGROUP.SAVE_SUCCESS') })
                    $state.go('frame.personalContactList', { groupid: $scope.groupid })
                  }
                }, function (result) {
                  if (result === 'fail') {
                    $loading.hide()
                    $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.EDITGROUP.FAIL_TO_ADDMEMBER') })
                    $state.go('frame.personalContact')
                  }
                })
              }
            }, function (error) {
              $loading.hide()
              console.log(error)
              $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.EDITGROUP.EDIT_FAIL') })
            })
          }
        }, function(error) {
          console.log(error)
        })
      }
    }
    // 分组成员选择模态框进入分组列出分组成员
    $scope.listGroupContacts = function (groupid, groupName) {
      $scope.showGroupContacts = true
      $scope.selectedGroupName = groupName
      resetStatus()
      $scope.isLoading = true
      contactService.getGroupPabContacts(groupid, false).then(function (data) {
        $scope.allCurrentGroupContacts = data
        $scope.total = data.length
        listContacts()
        showLoadMoreContact()
      }, function (error) {
        console.log(error)
        $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.FETCH_CONTACTSINFO_ERROR') })
      }).finally(
        function () {
          $scope.isLoading = false
        }
      )
    }
    // 控制显示加载更多或没有更多按钮（由于接口局限，此处的分页是前端拿到所有数据后进行的分页）
    function showLoadMoreContact() {
      if ($scope.contactsArrUnderGroup.length === $scope.total) {
        $scope.moreListData = false
      } else {
        $scope.moreListData = true
      }
    }
    // 根据start,limit显示联系人列表
    function listContacts() {
      if ($scope.start + $scope.limit < $scope.total) {
        $scope.contactsArrUnderGroup = $scope.contactsArrUnderGroup.concat($scope.allCurrentGroupContacts.slice($scope.start, $scope.start + $scope.limit))
        $scope.start = $scope.start + $scope.limit
      } else {
        $scope.contactsArrUnderGroup = $scope.contactsArrUnderGroup.concat($scope.allCurrentGroupContacts.slice($scope.start))
      }
    }
    // 加载更多联系人
    $scope.getMoreContactList = function () {
      listContacts()
      showLoadMoreContact()
    }
    $scope.backToGroupList = function () {
      $scope.showGroupContacts = false
    }
    // 由于通过字段在同一页控制显示分组列表和联系人列表, 因此页面切换时要重置分页数据状态，避免数据叠加错乱
    function resetStatus() {
      $scope.contactsArrUnderGroup = []
      $scope.total = 0
      $scope.start = 0
      $scope.allCurrentGroupContacts = null
    }
    // 选中联系人
    $scope.toggleSelect = function (contact) {
      if (contact.isChecked) {
        contact.isChecked = false
      } else {
        contact.isChecked = true
      }
    }
    // 创建新分组加入联系人成员需要利用pab:updateContacts接口实现
    function addGroupMember(newGroupId) {
      const deferred = $q.defer()
      const items = []
      if ($scope.newGroup.members.length === 0) {
        const temp = []
        if (angular.isArray($scope.oldMembers) && $scope.oldMembers.length !== 0) {
          $scope.oldMembers.forEach(function (member) {
            member.groups.forEach(function (groupid, index) {
              if (groupid === $scope.groupid) {
                member.groups.splice(index, 1)
              }
            })
            temp.push(member)
          })
          const params = {
            items: temp
          }
          contactListService.updateContacts(params).then(function (data) {
            if (data.code === 'S_OK') {
              deferred.resolve('success')
            }
          }, function (error) {
            console.log(error)
            deferred.reject('fail')
          })
        } else {
          deferred.resolve('success')
        }
      } else {
        $scope.newGroup.members.forEach(function (member) {
          const item = {
            groups: []
          }
          item.id = member.id
          item.groups = item.groups.concat(member.groups)
          item.groups.push($scope.groupid)
          item.groups = uniq(item.groups)
          items.push(item)
        })
        if ($stateParams.type === 'edit') {
          updateOldMembers()
        }
        const params = {
          items: items
        }
        contactListService.updateContacts(params).then(function (data) {
          if (data.code === 'S_OK') {
            deferred.resolve('success')
          }
        }, function (error) {
          console.log(error)
          deferred.reject('fail')
        })
      }
      return deferred.promise
    }
    // 将不属于编辑分组中成员的旧成员给去除
    function updateOldMembers() {
      const outMembers = []
      $scope.oldMembers.forEach(function (oldMember) {
        let isOut = true
        $scope.newGroup.members.forEach(function (newMember) {
          if (newMember.id === oldMember.id) {
            isOut = false
          }
        })
        if (isOut) {
          let oIndex
          oldMember.groups.forEach(function (item, index) {
            if (item === $scope.groupid) {
              oIndex = index
            }
          })
          oldMember.groups.splice(oIndex, 1)
          outMembers.push(oldMember)
        }
      })
      const params = {
        items: outMembers
      }
      if (angular.isArray(params.items) && params.items.length !== 0) {
        contactListService.updateContacts(params).then(function (data) {
          if (data.code === 'S_OK') {
          }
        }, function (error) {
          console.log(error)
        })
      }
    }
    // 清空分组联系人
    $scope.clearGroup = function () {
      if ($scope.disableClearButton) {
        $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.EDITGROUP.EMPTY_GROUP') })
        return
      }
      const confirmPopup = $ionicPopup.confirm({
        template: $translate.instant('ADDRESSBOOK.EDITGROUP.CONFIRM_CLEARALL'),
        cancelText: $translate.instant('OP.CANCEL'),
        cancelType: 'button-positive',
        okText: $translate.instant('OP.CONFIRM'),
        okType: 'button-default'
      })
      confirmPopup.then(function (res) {
        if (res) {
          const updateContacts = []
          if ($scope.newGroup.members && $scope.newGroup.members.length !== 0) {
            $scope.newGroup.members.forEach(function (item) {
              const contact = {
                id: '',
                groups: []
              }
              item.groups.forEach(function (group) {
                if (group !== $scope.groupid) {
                  contact.groups.push(group)
                }
              })
              contact.id = item.id
              updateContacts.push(contact)
            })
          }
          const params = {
            items: updateContacts
          }
          contactListService.updateContacts(params).then(function (data) {
            if (data.code === 'S_OK') {
              $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.EDITGROUP.CLEAR_SUCCESS') })
              $scope.newGroup.members = []
              $scope.$emit('addressbook.selectStatusRefresh')
              $scope.disableDeleteButton = false
            }
          }, function (error) {
            console.log(error)
            $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.EDITGROUP.CLEAR_FAIL') })
          })
        }
      }, function () {
      })
    }
    // 删除分组
    $scope.deleteGroup = function () {
      if ($scope.disableDeleteButton) {
        $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.EDITGROUP.PLEASE_CLEAR_ALL') })
        return
      }
      const confirmPopup = $ionicPopup.confirm({
        template: $translate.instant('ADDRESSBOOK.EDITGROUP.CONFIRM_DELETE_GROUP'),
        cancelText: $translate.instant('OP.CANCEL'),
        cancelType: 'button-positive',
        okText: $translate.instant('OP.CONFIRM'),
        okType: 'button-default'
      })
      confirmPopup.then(function (res) {
        if (res) {
          const newAllGroups = []
          contactListService.getAllGroups().then(function (data) {
            if (data && data.code === 'S_OK') {
              data.var.forEach(function (item) {
                if (item.id !== $scope.groupid) {
                  newAllGroups.push(item)
                }
              })
              const params = {
                deleteReservedGroup: true,
                groups: newAllGroups
              }
              contactListService.updateAllGroups(params).then(function (data) {
                if (data.code === 'S_OK') {
                  $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.EDITGROUP.DELETE_SUCCESS') })
                  $state.go('frame.personalContact')
                }
              }, function (error) {
                console.log(error)
                $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.EDITGROUP.DELETE_FAIL') })
              })
            }
          }, function () {
            $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.EDITGROUP.DELETE_FAIL') })
          })
        }
      })
    }
    // 根据当前联系组是否为空联系组来决定按钮的禁用状态
    function isCurrentGroupEmpty(groupid) {
      $scope.total = $stateParams.total
      if ($stateParams.total === '0') {
        $scope.disableClearButton = true
        $scope.disableDeleteButton = false
      } else {
        $scope.disableClearButton = false
        $scope.disableDeleteButton = true
      }
    }
    // 判断当前联系组是否为系统保留联系组来决定是否禁用删除按钮
    function isCurrentGroupReserved(groupid) {
      if ($rootScope.personalGroupArr) {
        $rootScope.personalGroupArr.forEach(function (item) {
          if (item.id === groupid) {
            $scope.isCurrentGroupReserved = item.reserved
            $scope.groupName = item.name
            $scope.newGroup.name = item.name
          }
        })
      }
    }
    // 联系组编辑状态下获取该组下原有的成员
    function getEditPageMembers() {
      contactService.getGroupPabContacts($scope.groupid, false).then(function (data) {
        $scope.oldMembers = JSON.parse(JSON.stringify(data))
        $scope.newGroup.members = data
        $scope.$emit('addressbook.selectStatusRefresh')
      }, function (error) {
        console.log(error)
        $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.EDITGROUP.FETCH_MEMBER_FAIL') })
      })
    }

    // 通讯录的显示隐藏配置
    $scope.ldvcappShow = serverConfig.contactsAttrShow('ldvcapp')
  }
]



// WEBPACK FOOTER //
// ./src/js/addressbook/organizational/contact/createContactGroupCtrl.js